<template>
  <div
    :class="classes"
    role="radio"
    tabindex="0"
    :aria-label="option.title"
    :aria-checked="ariaChecked"
    @click="onClick"
    @keydown.space.prevent="onClick"
    @keydown.enter.prevent="onClick"
  >
    <div class="trbo-a-gallery-item__image" :style="imageStyles" />
    <div class="trbo-a-gallery-item__content">
      <div class="trbo-a-gallery-item__title-actions">
        <div class="trbo-a-gallery-item__title">
          <div class="trbo-a-gallery-item__title__content">
            {{ option.title }}
          </div>
        </div>
        <div class="trbo-a-gallery-item__actions">
          <div v-if="hasInfoText" class="trbo-a-gallery-item__info-icon" @click.stop>
            <info-icon
              role="tooltip"
              tabindex="0"
              :main-icon="infoIcon"
              :is-opened="isOpened"
              :aria-labelledby="infoId"
              @click="onToggleIsOpened"
              @esc-pressed="closeToggle"
            />
          </div>
        </div>
      </div>
      <animation-height
        v-if="option.description"
        :is-visible="!isOpened"
        use-opacity
      >
        <div class="trbo-a-gallery-item__description">
          {{ option.description }}
        </div>
      </animation-height>
      <animation-height
        v-if="hasInfoText"
        :is-visible="isOpened"
        use-opacity
      >
        <div
          :id="infoId"
          :aria-hidden="!isOpened"
          class="trbo-a-gallery-item__info-text"
        >
          <info-text
            :is-opened="isOpened"
            :title="infoTitle"
            :description="infoDescription"
          />
        </div>
      </animation-height>
    </div>
  </div>
</template>

<script>
// @flow

import singleOptionMixin from '../../../../../mixins/singleOptionMixin'

import AnimationHeight from '../../../../AnimationHeight/AnimationHeight.vue'

import InfoIcon from '../../InfoIcon/InfoIcon.vue'
import InfoText from '../../InfoText/InfoText.vue'

export default {
  components: {
    AnimationHeight,
    InfoIcon,
    InfoText
  },
  mixins: [singleOptionMixin],
  props: {
    option: {
      type: Object, // QuestionOption
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpened: false
    }
  },
  computed: {
    classes () {
      return {
        group: true,
        'trbo-a-gallery-item': true,
        'trbo-a-gallery-item--with-description': !!this.option.description,
        'trbo-a-gallery-item--is-opened': this.isOpened,
        'trbo-a-gallery-item--is-selected': this.isSelected,
        'trbo-a-gallery-item--is-option-disabled': this.option.isDisabled
      }
    },
    imageStyles () {
      return {
        'background-image': `url(${this.option.imageUrl})`
      }
    },
    infoId () {
      return `info-${this.option.uuid}`
    },
    ariaChecked () {
      if (this.isSelected) return 'true'

      return undefined
    }
  },
  methods: {
    onToggleIsOpened () {
      this.isOpened = !this.isOpened
    },
    onClick (event: any): void {
      if (!this.option.isDisabled) {
        this.$emit('select', this.option)
      }
    },
    closeToggle () {
      this.isOpened = false
    }
  }
}
</script>

<style scoped src="./gallery-item.scss" />
